<div
  class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
  <div>
    <h5 class="mb-1 fw-bold text-black app-header">{{ pageName }}</h5>
    <p class="text-muted mb-0">{{ pageMessage }}</p>
  </div>
  <div class="d-flex gap-2 align-items-center">
     <!-- TODO add filter, and buttons here to make more module component -->
    <ng-content />
  </div>
</div>